import React, { useContext, useMemo } from 'react'

import { useRequest } from '../hooks/request'
import { VARIANT_SECONDARY } from '../constants/variants'
import { PATHS } from '../constants/paths'
import { history } from '../utils/history'
import { userCreate, userCreatePath } from '../requests/user'
import { ROLES, ROLES_OPTIONS_ARRAY } from '../constants/roles'
import { UserContext } from '../data/UserContext'
import { createOptionsFromEnum } from '../utils/createOptionsFromEnum'

import { PageTitle } from './common/PageTitle'
import { Button } from './common/Button'
import { Label } from './common/Typography'
import { Margin } from './common/Margin'
import { PageContent } from './layout/layout'
import { UserForm } from './UserForm'


const roleMap = {
  [ROLES.SUPER_ADMIN]: ROLES_OPTIONS_ARRAY,
  [ROLES.ADMIN]: ROLES_OPTIONS_ARRAY.filter((r) => r !== ROLES.SUPER_ADMIN),
  [ROLES.INTERNSHIP_DIRECTOR]: [ROLES.INTERNSHIP_DIRECTOR, ROLES.BASIC_USER],
}

export const UserCreate = () => {
  const { user } = useContext(UserContext)
  const userCreateRequest = useRequest({
    request: userCreate,
    handler: (p) => p.catch((e) => {
      if (e.errorCode === 13000) {
        return {
          email: 'emailAlreadyExists',
        }
      }

      if (e.errorCode === 17000) {
        return {
          email: 'mailingErrorTryLater',
        }
      }

      return {}
    }),
  })

  const options = useMemo(() => createOptionsFromEnum({ values: roleMap[user.role] }), [user])

  return (
    <>
      <PageTitle tradId="userCreate" backLink={PATHS.USER_LIST} backLinkTrad="userList" />
      <PageContent>
        {
          userCreateRequest.state.success ? (
            <>
              <Label tradId="userCreateSuccess" />
              <Margin v={30} />
              <div>
                <Button
                  tradId="createAnother"
                  variant={VARIANT_SECONDARY}
                  onClick={userCreateRequest.cleanState}
                  filled
                />
                <Margin h={10} />
                <Button link to={PATHS.USER_LIST} tradId="seeList" variant={VARIANT_SECONDARY} />
              </div>
            </>
          ) : (

            <UserForm
              roleOptions={options}
              cancelLabel="cancelBack"
              confirmLabel="createAUser"
              path={userCreatePath}
              onSubmit={userCreateRequest.fetch}
              onCancel={() => history.goBack}
            />
          )
        }
      </PageContent>
    </>
  )
}
